import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import homeImage from '../assets/landingPage.png';
import { Button } from '@src/components/ui';
import { useAuth } from '../contexts/AuthContext';
import styles from './Home.module.scss';
const Home = () => {
    const { getClinicStatus, isAuthenticated } = useAuth();
    useEffect(() => {
        getClinicStatus().then((res) => console.log(res));
    });
    return (_jsx("main", { className: styles.home, children: _jsxs("section", { className: styles.hero, children: [_jsx("img", { src: homeImage, alt: "Veterinary technology for animal care", className: styles.heroImage, width: "1920", height: "1080" }), _jsxs("div", { className: styles.heroContent, children: [_jsx("h1", { children: "Advancing Veterinary Medicine Through Innovation." }), _jsx("p", { children: "Empowering clinics with advanced veterinary technology and trusted treatment solutions designed for better patient outcomes." }), !isAuthenticated && (_jsx(Button, { href: "/account/createAccount", variant: "primaryV2", size: "large", label: "Create an Account to Get Started", className: styles.createAccountButton }))] })] }) }));
};
export default Home;
